import {Component, EventEmitter, inject, Input, NgZone, Output, ViewChild} from '@angular/core';
import {AikTDViewerComponent, FileLoadingWorkflowEnum} from "@aiknow-srl/aik-ngx-3dviewer";
import {ThreeDimModel} from "../../../models/widget/threedimmodel/ThreeDimModel";
import {UserMetricInstance} from "../../../models/user/Metric/UserMetricInstance";
import {BaseComponent} from "../../BaseComponent";
import {S3ManagerService} from "../../../services/s3-manager.service";
import {DashboardService} from "../../../services/dashboard/dashboard.service";

@Component({
  selector: 'app-three-dim-viewer',
  templateUrl: './three-dim-viewer.component.html',
  styleUrls: ['./three-dim-viewer.component.css', 'three-dim-model-widget.component.css']
})
export class ThreeDimViewerComponent extends BaseComponent {

  @Input('keyMeshesList') keyMeshesList: Map<number, UserMetricInstance[]> = new Map<number, UserMetricInstance[]>();
  @Output('selectedMeshInstanceId') selectedMeshInstanceIdChanged = new EventEmitter<any>();
  @Output('loadingWorkflowStatus') loadingWorkflowStatusChanged = new EventEmitter<any>();
  @Output('deleteMeasure') deleteMeasure = new EventEmitter<any>();
  @ViewChild('threeDViewer') threeDViewer?: AikTDViewerComponent;
  fileTotalDimension = 1;
  fileLoadedDimension = 0;
  loadingErrorMessage?: string;
  selectedMeshInstanceId?: number;
  loadingWorkflowStatus: FileLoadingWorkflowEnum = FileLoadingWorkflowEnum.INIT;
  @Input() isWidget: boolean = false;
  tdVisible: boolean = true;
  s3ManagerService: S3ManagerService = inject(S3ManagerService);
  dashboardService: DashboardService = inject(DashboardService);
  protected localUrl = "";
  protected readonly FileLoadingWorkflowEnum = FileLoadingWorkflowEnum;
  private ngZone = inject(NgZone);

  private _theThreeDimModel!: ThreeDimModel;

  get theThreeDimModel(): ThreeDimModel {
    return this._theThreeDimModel;
  }

  @Input('theThreeDimModel') set theThreeDimModel(value: ThreeDimModel) {
    this._theThreeDimModel = value;
    this.loadModelFromCache();
  }

  private _localBlob?: File;

  @Output() localBlobChange = new EventEmitter<File>();
  get localBlob(): File | undefined {
    return this._localBlob;
  }

  @Input('localBlob') set localBlob(value: File | undefined) {
    this._localBlob = value;
    this.localBlobChange.emit(value);
  }

  loadModelFromCache() {
    caches.open(this.appService.CACHE_NAME)
      .then(cache => {
        return cache.match(this.theThreeDimModel.file.objKey);
      })
      .then(response => {
        if (response) {
          response.blob().then(blob => {
            let splitName = this.theThreeDimModel.file.objKey.split('/');
            this.localBlob = new File([blob], splitName[splitName.length - 1]);
            // this.localUrl = URL.createObjectURL(blob);
          })
        } else {
          this.download3DItem();
        }
      })
  }

  printLoadingStatus() {
    // {{FileLoadingWorkflowEnum[loadingWorkflowStatus]}}
    switch (this.loadingWorkflowStatus) {
      case FileLoadingWorkflowEnum.INIT:
      case FileLoadingWorkflowEnum.NO_FILE_FOUND:
      case FileLoadingWorkflowEnum.LOADING:
      case FileLoadingWorkflowEnum.IMPORTING:
      case FileLoadingWorkflowEnum.VISUALIZING:
        return FileLoadingWorkflowEnum[this.loadingWorkflowStatus];
      case FileLoadingWorkflowEnum.COMPLETED:
        return "";
      case FileLoadingWorkflowEnum.ERROR:
        return 'Error';
    }
  }


  format(ratio: number) {
    return `Loading: ${(ratio * 100).toFixed(0)}%`;
  }

  deselectMesh() {
    this.selectedMeshInstanceId = undefined;
  }


  reload3DItem() {
    this.tdVisible = false;
    this.cdr.detectChanges();
    this.tdVisible = true
  }

  download3DItem() {
    if (!!this.theThreeDimModel.file.objKey) {
      caches.open(this.appService.CACHE_NAME)
        .then(cache => {
          const url = this.s3ManagerService.getSignedUrlByKey(this.theThreeDimModel.file.objKey);
          if (url != null) {
            this.loadingWorkflowStatus = FileLoadingWorkflowEnum.LOADING;
            fetch(url)
              .then(async response => {
                if (!response.ok) {
                  return Promise.reject(new Error('Network response was not ok'));
                }

                cache.put(this.theThreeDimModel.file.objKey, response.clone());

                response.clone().blob().then(blob => {
                  let splitName = this.theThreeDimModel.file.objKey.split('/');
                  this.localBlob = new File([blob], splitName[splitName.length - 1]);
                });

                // Log the download progress
                const contentLength = response.headers.get('Content-Length');
                if (contentLength) {
                  this.fileTotalDimension = parseInt(contentLength, 10);
                  this.fileLoadedDimension = 0; // Reset the loaded dimension

                  const reader = response.body!.getReader();
                  const stream = new ReadableStream({
                    start: (controller) => {
                      const read = () => {
                        reader.read().then(({done, value}) => {
                          if (done) {
                            controller.close();
                            return;
                          }

                          // Update fileLoadedDimension in Angular's zone
                          this.ngZone.run(() => {
                            this.fileLoadedDimension += value.length;
                            // Trigger change detection manually
                            this.cdr.detectChanges();
                          });

                          controller.enqueue(value);

                          read(); // Recursively call read to keep reading the stream
                        });
                      };

                      read();
                    }
                  });

                  // Return a new response with the stream
                  return new Response(stream);
                } else {
                  // If no content-length header is available, just return the response as it is
                  return response;
                }

              })
          }
        })
        .catch(error => {
          console.error('Error storing blob in cache:', error);
        });
    }
  }
}
